import ProductDetailViewNewKiosk from './ProductDetailViewNewKiosk.jsx';

export default ProductDetailViewNewKiosk;


// WEBPACK FOOTER //
// ./src/components/ProductDetailViewNewKiosk/index.jsx